import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { ACTIONS as MAIN_ACTIONS } from "../redux/main";

const useLogged = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(MAIN_ACTIONS.fetchUserInfo());
  }, [dispatch]);

  return null;
};

export default useLogged;
